import React from 'react';
import dayjs from 'dayjs';
import { getI18n } from 'react-i18next';
import { ColumnsType } from 'antd/lib/table';
import TableHeader from '~/components/views/agent/tableElements/TableHeader';

function createdCell(): ColumnsType<any>[0] {
  return {
    title: () => <TableHeader title={getI18n().t('Created', { ns: 'agent' })} sortingDataKey="created" />,
    dataIndex: 'created',
    key: 'created',
    render: (date: string) => <span key={date}>{dayjs(date).format('DD/MM/YYYY')}</span>,
    width: 120,
  };
}

export default createdCell;
